import { useCallback, useRef, useState } from 'react'

type Scrub = {
	/** What the slider shows: the position, or where it is being dragged. */
	value: number
	onChange: (value: number) => void
	/** Pointer up, key up, focus lost: the drag is over. */
	onRelease: () => void
}

/**
 * A position slider that follows the playback until it is dragged, and moves
 * the playback once, when let go - not on every step of the drag, each of
 * which would be a request to the server.
 */
export const useScrub = (
	position: number,
	commit: (value: number) => void
): Scrub => {
	const [dragged, setDragged] = useState<number | null>(null)
	const latest = useRef<number | null>(null)

	const onChange = useCallback((value: number) => {
		latest.current = value
		setDragged(value)
	}, [])

	const onRelease = useCallback(() => {
		const value = latest.current
		if (value === null) {
			return
		}
		latest.current = null
		setDragged(null)
		commit(value)
	}, [commit])

	return { value: dragged ?? position, onChange, onRelease }
}
